// 開始と終了の日時を設定
const startDateTime = new Date('2024-12-24T16:00:00').getTime(); // 開始日時
const endDateTime = new Date('2025-02-28T11:59:59').getTime();    // 終了日時

function updateCountdown() {
    const now = new Date().getTime();
    const startDistance = startDateTime - now;
    const endDistance = endDateTime - now;
    const countdownEl = document.getElementById("countdown");

    // イベントがまだ開始していない場合は「開始まで」を表示
    if (startDistance > 0) {
        countdownEl.innerHTML = `SALE開始まで：${formatCountdown(startDistance)}`;
    }
    // イベントが開始され、まだ終了していない場合は「終了まで」を表示
    else if (endDistance > 0) {
        //countdownEl.innerHTML = `イベント終了まで：${formatCountdown(endDistance)}`;//
         countdownEl.innerHTML = `SALE開催中！`;
    }
    // イベントが終了した場合
    else {
        countdownEl.innerHTML = "イベントは終了しました";
    }
}

// カウントダウンを整形する関数
function formatCountdown(distance) {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    return `${days}日 ${hours}時間 ${minutes}分 ${seconds}秒`;
}

// 1秒ごとにカウントダウンを更新
setInterval(updateCountdown, 1000);

